export const ArrowNextIcon = () => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.93477 7.30977L5.55977 11.6848C5.51913 11.7254 5.47087 11.7577 5.41776 11.7797C5.36465 11.8017 5.30773 11.813 5.25024 11.813C5.19276 11.813 5.13584 11.8017 5.08273 11.7797C5.02962 11.7577 4.98136 11.7254 4.94071 11.6848C4.90006 11.6441 4.86782 11.5959 4.84582 11.5428C4.82382 11.4897 4.8125 11.4327 4.8125 11.3752C4.8125 11.3178 4.82382 11.2608 4.84582 11.2077C4.86782 11.1546 4.90006 11.1064 4.94071 11.0657L9.00673 7.00024L4.94071 2.93477C4.85862 2.85268 4.8125 2.74134 4.8125 2.62524C4.8125 2.50915 4.85862 2.3978 4.94071 2.31571C5.0228 2.23362 5.13415 2.1875 5.25024 2.1875C5.36634 2.1875 5.47768 2.23362 5.55977 2.31571L9.93477 6.69071C9.97545 6.73134 10.0077 6.7796 10.0297 6.83271C10.0518 6.88582 10.0631 6.94275 10.0631 7.00024C10.0631 7.05774 10.0518 7.11467 10.0297 7.16778C10.0077 7.22089 9.97545 7.26914 9.93477 7.30977Z'
        fill='currentColor'
      />
    </svg>
  );
};
